import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccountUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M9.781 9.5C12.094 9.5 14 11.406 14 13.719v.781a1.5 1.5 0 0 1-1.5 1.5h-11A1.48 1.48 0 0 1 0 14.5v-.781C0 11.406 1.875 9.5 4.188 9.5 5.094 9.5 5.5 10 7 10c1.469 0 1.875-.5 2.781-.5m2.719 5v-.781A2.72 2.72 0 0 0 9.781 11c-.469 0-1.187.5-2.781.5-1.625 0-2.344-.5-2.812-.5-1.5 0-2.688 1.219-2.688 2.719v.781zM7 9C4.5 9 2.5 7 2.5 4.5 2.5 2.031 4.5 0 7 0c2.469 0 4.5 2.031 4.5 4.5C11.5 7 9.469 9 7 9m0-7.5c-1.656 0-3 1.375-3 3a3 3 0 0 0 3 3c1.625 0 3-1.344 3-3 0-1.625-1.375-3-3-3"
    />
  </svg>
);
export default SvgAccountUser;
